import React from "react";

function collectStrings(value, output = []) {
  if (!value) return output;

  if (typeof value === "string") {
    const clean = value.replace(/\s+/g, " ").trim();
    if (clean) output.push(clean);
    return output;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => collectStrings(item, output));
    return output;
  }

  if (typeof value === "object") {
    for (const key of [
      "display_name",
      "name",
      "institution_name",
      "organization",
      "organisation",
      "university",
      "institution",
      "affiliation",
      "affiliations",
      "institutions",
    ]) {
      if (value[key]) collectStrings(value[key], output);
    }
  }

  return output;
}

export function explicitInstitutions(root = {}) {
  const values = [];

  for (const key of [
    "university",
    "institution",
    "institution_name",
    "institutions",
    "affiliation",
    "affiliations",
    "author_affiliations",
    "authorships",
    "organizations",
    "organisations",
  ]) {
    if (root?.[key]) collectStrings(root[key], values);
  }

  for (const container of [
    root?.metadata,
    root?.source_metadata,
    root?.openalex,
    root?.crossref,
  ]) {
    if (!container || typeof container !== "object") continue;
    for (const key of [
      "institution",
      "institutions",
      "affiliation",
      "affiliations",
      "authorships",
    ]) {
      if (container[key]) collectStrings(container[key], values);
    }
  }

  return [...new Set(values.filter(Boolean))];
}

function universityLike(name = "") {
  const value = String(name).toLowerCase();
  return [
    "university",
    "universitet",
    "université",
    "universidad",
    "università",
    "college",
    "høgskole",
    "hogskole",
    "school of",
    "faculty of",
    "institute of",
    "institutt",
  ].some((token) => value.includes(token));
}

export default function InstitutionBadge({ root, compact = false }) {
  const institutions = explicitInstitutions(root);
  if (!institutions.length) return null;

  const shown = institutions.slice(0, compact ? 1 : 2);
  const extra = institutions.length - shown.length;

  return (
    <div className={`rr-inst-badges ${compact ? "compact" : ""}`}>
      {shown.map((name) => (
        <span
          key={name}
          className={`rr-inst-badge ${universityLike(name) ? "university" : "institution"}`}
          title="Explicit institution / affiliation metadata from this StudyRoot"
        >
          <i aria-hidden="true">⌂</i>
          {name}
        </span>
      ))}
      {extra > 0 ? <span className="rr-inst-more">+{extra}</span> : null}
    </div>
  );
}
